import i18n from '@/i18n';

const configForm = () => {
    return {
        configFieldInput: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorCustomMess: '',
            errorField: 'ページタイトル',
            valueSync: '',
            typesValidate: ['max100']
        },
        configFieldSelect: {
            trackBy: 'id',
            label: 'value',
            isRemove: false,
            error: false,
            multiple: true
        },
        configFieldSelectProvince: {
            trackBy: 'id',
            label: 'value',
            isRemove: false,
            error: false,
            multiple: true
        }
    };
};
const configs = {
    configTableAnalytics: () => {
        return {
            widthAction: 100,
            headers: [
                {
                    label: 'ID',
                    sort: {
                        type: 'desc',
                        order_by: 'id'
                    },
                    width: 80
                },
                {
                    label: '回答日時',
                    width: 200
                }
            ]
        };
    },
    configTableMailSend: () => {
        return {
            widthAction: 0,
            headers: [
                {
                    label: 'ID',
                    width: 80
                },
                {
                    label: 'メールアドレス',
                    width: 300
                },
                {
                    label: '本番URL',
                    width: 500
                },
                {
                    label: 'メール有効開始時間',
                    width: 300
                },
                {
                    label: 'メール有効終了時間',
                    width: 300
                }
            ]
        };
    },
    configTableSerialCode: () => {
        return {
            widthAction: 0,
            headers: [
                {
                    label: 'No.',
                    width: 60
                },
                {
                    label: 'シリアルコード',
                    width: 130
                },
                {
                    label: '抽選パターン',
                    width: 120
                },
                {
                    label: '賞品名',
                    width: 120
                },
                {
                    label: '賞品種別',
                    width: 120
                },
                {
                    label: '抽選日時',
                    width: 185
                },
                {
                    label: '抽選結果',
                    width: 120
                },
                {
                    label: '賞品コード',
                    width: 101
                },
                {
                    label: i18n.t('managerForm.settingPage.pageTypeB.personalUrl'),
                    width: 300
                },
                {
                    label: '個人情報登録ステータス',
                    width: 185
                },
                {
                    label: '回答日時',
                    width: 200
                }
            ]
        };
    },
    configTableFilterBlock: {
        headers: [
            {
                label: '項目'
            },
            {
                label: '条件'
            },
            {
                label: '値'
            },
            {
                label: 'コマンド'
            }
        ]
    },
    configModalAnalyticsDetail: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: true,
        centered: true,
        validate: true,
        size: 'lg'
    },
    configModalDownloadData: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: true,
        centered: true,
        validate: true,
        size: 'xl',
        hideCloseButton: false,
        listBlockSerial: []
    },
    configModalAnalyticsEdit: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: false,
        centered: true,
        validate: true,
        size: 'lg'
    },
    configPage: {
        total: 0,
        limit: 10,
        page: 1
    },
    configKeyword: {
        arrayTag: [],
        placeholder: 'キャンペーン名称、フォーム名、公開URL、ステータス、スケジュール',
        isShowLable: true
    },
    CHOICE_CONDITION_FILTER: [
        {
            id: 1,
            label: 'AND',
            value: 'AND'
        },
        {
            id: 2,
            label: 'OR',
            value: 'OR'
        }
    ],
    activeAccordions() {
        return { searchBlocks: false };
    },
    configModalProgressDeleteAnalytics: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: true,
        centered: true,
        validate: true,
        hideCloseButton: true,
        size: 'md',
        title_excute: ''
    }
};

export { configForm, configs };
